import { useEffect } from 'react';

import { useShallow } from 'zustand/react/shallow';

import { IStoryMeta, StoryRenderModes } from 'types/story';

import { TStoryMode, useStoryStateStore } from 'stores/storyStateStore';

export const useSetupStoryState = () => {
  const setStoryState = useStoryStateStore(state => state.setStoryState);
  const resetStoryState = useStoryStateStore(state => state.resetStoryState);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => resetStoryState, []);

  const lazySetupStoryState = (
    id: string,
    mode: TStoryMode,
    meta: IStoryMeta | null,
  ) => setStoryState({ id, mode, meta });

  return { lazySetupStoryState };
};

export const useStoryState = () => {
  const { id, mode, meta } = useStoryStateStore(
    useShallow(({ id, mode, meta }) => ({ id, mode, meta })),
  );

  const inEditor = mode === 'editor';
  const inPreview = mode === 'preview';
  const inView = mode === 'view';
  const inPoster = mode === 'poster';

  const isBlockContent = meta?.renderMode === StoryRenderModes.BLOCK;
  const isFlexibleContent =
    (meta?.renderMode || StoryRenderModes.FLEXIBLE) ===
    StoryRenderModes.FLEXIBLE;

  return {
    id,
    mode,
    meta,
    inEditor,
    inPreview,
    inView,
    inPoster,
    isBlockContent,
    isFlexibleContent,
  };
};
